import { OrderedMap } from 'immutable';
import WineSkuConstants from '../constants/WineSkuConstants';
import WineSku from '../models/WineSku';
import WineSkuStore from '../stores/WineSkuStore';

const WineSkuActions = {
  fetch(context, payload) {
    context.dispatch(WineSkuConstants.FETCH_WINE_SKU_START, payload.id);
    return context
      .delectoryApi
      .wineSkus
      .wineSku({id: payload.id})
      .then(responsePayload => {
        let wineSku = new WineSku(responsePayload.wine_sku);
        context.dispatch(WineSkuConstants.FETCH_WINE_SKU_SUCCESS, wineSku);
      })
      .catch(err => {
        context.dispatch(WineSkuConstants.FETCH_WINE_SKU_FAILURE, {entityId: payload.id, error: err});
        if(err.code === 2000) {
          err.statusCode = 404;
        }
        throw err;
      });
  },

  list(context, payload) {
    // optionally provide 'forceRetry' in payload to allow subsequent identical requests
    payload.pagination = payload.pagination || WineSkuStore.defaultPagination;
    payload.sorter = payload.sorter || WineSkuStore.defaultSorter;
    payload.filters = payload.filters || [];

    let requestPayload = {
      filters: payload.filters,
      pagination: payload.pagination,
      sort: [payload.sorter]
    };

    context.dispatch(WineSkuConstants.LIST_WINE_SKUS_START, payload);
    // Remove optional args
    delete payload.forceRetry;

    return context
      .delectoryApi
      .wineSkus
      .list(requestPayload)
      .then(responsePayload => {
        let wineSkus = responsePayload.wine_skus.reduce((map, wineSku) => {
          return map.set(wineSku.id, new WineSku(wineSku));
        }, new OrderedMap());
        payload.pagination.totalResults = responsePayload.total_results;
        context.dispatch(WineSkuConstants.LIST_WINE_SKUS_SUCCESS, {
          entities: wineSkus,
          filters: payload.filters,
          pagination: payload.pagination,
          sorter: payload.sorter,
          suggestedFilters: responsePayload.suggested_filters
        });
      })
      .catch(err => {
        context.dispatch(WineSkuConstants.LIST_WINE_SKUS_FAILURE, {error: err});
      });
  }
};

export default WineSkuActions;



// WEBPACK FOOTER //
// banquet/actions/WineSkuActions.js